const wordsPerMin = process.env.REACT_APP_WORDS_PER_MIN;
export const calculateEstimatedReadTime = (content) => {
  const words = content?.replace(/<\/?[^>]+(>|$)/g, "").split(" ").length || 0;
  return Math.round(Math.max(words / wordsPerMin, 1));
};
